export default {
    appleMaps: {
        title: 'Apple Maps',
        value: 'appleMaps',
        transportTypes: [
            {
                value: 'd',
                label: 'Auto'
            },
            {
                value: 'w',
                label: 'Lopen'
            }
        ],
        transportType: {
            car: 'd',
            walk: 'w'
        }
    },
    googleMaps: {
        title: 'Google Maps',
        value: 'googleMaps',
        transportTypes: [
            {
                value: 'driving',
                label: 'Auto'
            },
            {
                value: 'bicycling',
                label: 'Fietsen'
            },
            {
                value: 'walking',
                label: 'Lopen'
            }
        ],
        transportType: {
            car: 'driving',
            bike: 'bicycling',
            walk: 'walking'
        }
    },
    mapsme: {
        title: 'Mapsme',
        value: 'mapsme',
        transportTypes: [
            {
                value: 'vehicle',
                label: 'Auto'
            },
            {
                value: 'bicycle',
                label: 'Fietsen'
            },
            {
                value: 'pedestrian',
                label: 'Lopen'
            }
        ],
        transportType: {
            car: 'vehicle',
            bike: 'bicycle',
            walk: 'pedestrian'
        }
    },
    organicMaps: {
        title: 'Organic Maps',
        value: 'organicMaps',
        transportTypes: [
            {
                value: 'vehicle',
                label: 'Auto'
            },
            {
                value: 'bicycle',
                label: 'Fietsen'
            },
            {
                value: 'pedestrian',
                label: 'Lopen'
            }
        ],
        transportType: {
            car: 'vehicle',
            bike: 'bicycle',
            walk: 'pedestrian'
        }
    },
    osmand: {
        title: 'OsmAnd',
        value: 'osmand',
        transportTypes: [
            {
                value: 'car',
                label: 'Auto'
            },
            {
                value: 'bicycle',
                label: 'Fietsen'
            },
            {
                value: 'pedestrian',
                label: 'Lopen'
            },
            {
                value: 'truck',
                label: 'Vrachtwagen'
            },
            {
                value: 'moped',
                label: 'Scooter'
            }
        ],
        transportType: {
            car: 'vehicle',
            bike: 'bicycle',
            walk: 'pedestrian'
        }
    },
    sygic: {
        title: 'Sygic',
        value: 'sygic',
        transportTypes: [
            {
                value: 'drive',
                label: 'Auto'
            },
            {
                value: 'walk',
                label: 'Lopen'
            }
        ],
        transportType: {
            car: 'drive',
            walk: 'walk'
        }
    },
    tomtomgo: {
        title: 'Tomtom GO',
        value: 'tomtomgo',
        transportTypes: [
            {
                value: 'car',
                label: 'Auto'
            }
        ],
        transportType: {
            car: 'car'
        }
    },
    waze: {
        title: 'Waze',
        value: 'waze',
        transportTypes: [
            {
                value: 'car',
                label: 'Auto'
            }
        ],
        transportType: {
            car: 'car'
        }
    }
}
